import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import Header from "../Components/Header";
import "../Components/DoctoeAppointment.css";
import {
    MDBCol,
    MDBContainer,
    MDBRow,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBBadge
} from "mdb-react-ui-kit";
import DataTable from "react-data-table-component";
import { Spinner, Button } from "reactstrap";
import { Nav, NavLink } from "react-bootstrap";
import { BASE_URL } from "../config";

export default function FinanceDetail() {
    const { id } = useParams();
    const [financeDetails, setFinanceDetails] = useState([]);
    const [loading, setLoading] = useState(true);

    const [filter, setFilter] = useState("Pending");

    const fetchFinanceDetails = useCallback(async () => {
        setLoading(true);
        let endpoint = "";

        if (filter === "Pending") {
            endpoint = "PaymentPendingDetails";
        } else if (filter === "Processing") {
            endpoint = "PaymentProcessingDetails";
        } else if (filter === "Paid") {
            endpoint = "PaymentPaidDetails";
        }

        try {
            const response = await fetch(
                `${BASE_URL}${endpoint}?id=${id}`,
                {
                    method: "GET",
                    headers: { Accept: "application/json" },
                }
            );

            const data = await response.json();
            console.log("Finance Details:", data);

            if (data.responseCode === "0000") {
                setFinanceDetails(data.getPaymentDetails || []);
            } else {
                setFinanceDetails([]);
            }
        } catch (error) {
            console.error("Error fetching finance details:", error);
        } finally {
            setLoading(false);
        }
    }, [id, filter]);

    useEffect(() => {
        fetchFinanceDetails();
    }, [fetchFinanceDetails]);

    const baseColumns = [
        {
            name: <span className="fw-bold">Doctor Name</span>,
            selector: (row) => row.doctorName || "N/A",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Patient Name</span>,
            selector: (row) => row.patientName || "N/A",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Appointment No</span>,
            selector: (row) => row.appointmentNo || "N/A",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Appointment Date</span>,
            selector: (row) => row.appointmentDate || "N/A",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Appointment Time</span>,
            selector: (row) => row.appointmentTime || "N/A",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Amount</span>,
            selector: (row) => row.amount || "N/A",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Finance Status</span>,
            selector: (row) => (
                <MDBBadge
                    color={
                        row.financeStatus === "Pending"
                            ? "warning"
                            : row.financeStatus === "Paid"
                                ? "success"
                                : "info"
                    }
                    pill
                >
                    {row.financeStatus || "N/A"}
                </MDBBadge>
            ),
            sortable: true,
        },
        {
            name: <span className="fw-bold">Payment Date</span>,
            selector: (row) => row.paymentDate || "—",
            sortable: true,
        },
        {
            name: <span className="fw-bold">Remarks</span>,
            selector: (row) => row.financeRemarks || "—",
            sortable: true,
        },
    ];

    return (
        <MDBContainer fluid className="container-fluid py-1">
            <Header />
            <MDBRow className="d-flex justify-content-center align-items-center h-45">
                <MDBCol xs="12" sm="12" md="12" lg="12">
                    <MDBCard
                        className="card-registration card-registration-2 mt-3"
                        style={{ borderRadius: "12px" }}
                    >
                        <MDBCardHeader className="text-center bg_primary text-white border-0">
                            <h5 className="fw-bold mb-1">Finance Details</h5>
                        </MDBCardHeader>

                        {/* Filter Buttons */}

                        {loading ? (
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: "200px" }}
                            >
                                <Spinner size="lg" />
                            </div>
                        ) : (
                            <>
                                <ul tabs className="bg_light p-1 nav-tabs">
                                    {["Pending", "Processing", "Paid"].map((status) => (
                                        <NavLink
                                            key={status}
                                            className={filter === status ? "d-inline-flex active" : "d-inline-flex"}
                                            onClick={() => setFilter(status)}
                                        >
                                            {status}
                                        </NavLink>
                                    ))}
                                </ul>
                                <MDBCardBody className="p-0">
                                    <DataTable
                                        columns={baseColumns}
                                        data={financeDetails}
                                        responsive
                                        highlightOnHover
                                        pagination
                                        striped
                                    />
                                </MDBCardBody>

                            </>

                        )}
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}
